"use client";

import React from "react";
import { StyledDiv } from "./widgetVideoGuide.styles";
import { IPlatform, IPlugin } from "../../types";

function getYoutubeEmbedUrl(url: string): string | null {
  if (!url) return null;
  
  // Handle various YouTube URL formats
  if (url.includes("youtube.com/watch?v=")) {
    const videoId = url.split("v=")[1]?.split("&")[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
  }
  
  if (url.includes("youtu.be/")) {
    const videoId = url.split("youtu.be/")[1]?.split("?")[0];
    return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
  }
  
  if (url.includes("youtube.com/embed/")) {
    return url;
  }
  
  return null;
}

export const WidgetVideoGuideSSR = ({
  widget,
  videoUrl,
  staticMode = false,
}: {
  widget: IPlugin;
  platform?: IPlatform;
  videoUrl?: string;
  staticMode?: boolean;
}) => {
  const sourceUrl = videoUrl || widget.videoUrl;
  
  if (!sourceUrl) {
    return null;
  }

  const embedUrl = getYoutubeEmbedUrl(sourceUrl);
  
  if (!embedUrl) {
    return null;
  }

  return (
    <StyledDiv className={`${staticMode ? "static" : ""}`}>
      <div className="video-container">
        <iframe
          src={embedUrl}
          title={`${widget.name} Tutorial`}
          width="100%"
          height={staticMode ? "auto" : "523"}
          style={{ 
            maxWidth: "930px", 
            borderRadius: "10px", 
            minHeight: "315px",
            border: "none"
          }}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </StyledDiv>
  );
};

